const LangConfig = {
  zh: {
    loginExpireModal: {
      title: '登录态失效',
      description: '请点击确定重新登录'
    },
    ipLimitModal: {
      title: 'IP访问限制',
      description:
        '抱歉，您当前登录的IP为{{ip}}，为限制访问的IP段，如有疑问，请联系企业运营管理人员进行IP访问限制的配置变更'
    }
  },
  en: {
    loginExpireModal: {
      title: 'Login state is invalid',
      description: 'Please click OK to log in again'
    },
    ipLimitModal: {
      title: 'IP access restriction',
      description:
        'Your login IP is {{ip}} in the restricted-access IP network segment, please use the authorized IP to log in to the system'
    }
  }
};

//与云API保持一致
LangConfig['zh-CN'] = LangConfig['zh'];
LangConfig['en-US'] = LangConfig['en'];

export default LangConfig;
